/* ──────────────────────────────────────────────────────────────────────────
   DAW — Compléments : rubriques dépliables, écran de configuration, ajout.

   Tout est délégué au document : le tiroir panier est reconstruit par Dawn à
   chaque changement de panier, aucun écouteur posé sur ses éléments ne survit.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  /* le fichier est appelé par le tiroir et par la section produit : on ne
     branche les écouteurs qu'une fois, sinon chaque clic compterait double. */
  if (window.DAW_COMPLEMENTS) return;
  window.DAW_COMPLEMENTS = true;

  var cache = {};

  function euros(centimes) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(centimes, window.DAW_MONEY_FORMAT || '{{amount_with_comma_separator}} €');
    }
    return (centimes / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function nombreDe(texte) {
    var m = String(texte || '').replace(',', '.').match(/[\d.]+/);
    return m ? Math.round(parseFloat(m[0])) : 0;
  }

  /* les noms d'options, quelle que soit la forme renvoyée par /products/x.js */
  function nomsOptions(produit) {
    if (!produit.options) return [];
    return produit.options.map(function (o) {
      return typeof o === 'string' ? o : o.name;
    });
  }

  function estLargeur(nom) {
    var n = (nom || '').toLowerCase();
    return n.indexOf('entre') === 0 || n.indexOf('entre-corne') >= 0 || n.indexOf('entrecorne') >= 0;
  }

  function estBoucle(nom) {
    return (nom || '').toLowerCase().indexOf('boucle') >= 0;
  }

  /* Dans le tiroir, chaque rubrique est glissée sous sa montre et forme donc son
     propre bloc ; l'écran de choix, lui, est unique. Le périmètre commun est le
     tiroir. Sur la fiche produit, c'est le bloc. */
  function perimetre(el) {
    return el.closest('cart-drawer') || el.closest('.daw-comp') || document;
  }

  /* Pendant la configuration, le tiroir ne doit plus montrer le panier : on pose
     une classe sur <cart-drawer> et le CSS efface la liste et le pied. Le retour
     et l'ajout la retirent. On ne remonte pas depuis « cfg » pour cela : après un
     ajout, Dawn a déjà reconstruit le tiroir et l'écran de choix est détaché du
     document — il faut donc retrouver le tiroir vivant. */
  function modeConfig(cfg, actif) {
    if (cfg) cfg.hidden = !actif;
    if (!cfg || cfg.dataset.tiroir !== '1') return;
    var tiroir = document.querySelector('cart-drawer');
    if (tiroir) tiroir.classList.toggle('daw-en-config', actif);
  }

  /* ── rubriques dépliables ───────────────────────────────────────────────── */
  document.addEventListener('click', function (ev) {
    var tete = ev.target.closest('[data-daw-volet]');
    if (!tete) return;
    var zone = perimetre(tete);
    var corps = document.getElementById(tete.getAttribute('aria-controls'));
    if (!corps) return;
    var ouvert = tete.getAttribute('aria-expanded') === 'true';
    if (!ouvert && zone) {
      /* une seule rubrique ouverte à la fois : deux rails dépliés, c'est la surcharge */
      zone.querySelectorAll('[data-daw-volet]').forEach(function (autre) {
        if (autre === tete) return;
        autre.setAttribute('aria-expanded', 'false');
        var c = document.getElementById(autre.getAttribute('aria-controls'));
        if (c) c.hidden = true;
      });
    }
    tete.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
    corps.hidden = ouvert;
  });

  /* ── ouverture de l'écran de configuration ──────────────────────────────── */
  document.addEventListener('click', function (ev) {
    var declencheur = ev.target.closest('[data-daw-ouvrir]');
    if (!declencheur) return;
    ev.preventDefault();
    ouvrir(declencheur);
  });

  function ouvrir(declencheur) {
    var handle = declencheur.getAttribute('data-daw-ouvrir');
    var cfg = perimetre(declencheur).querySelector('.daw-cfg');
    if (!cfg || !handle) return;

    /* Le panier peut contenir plusieurs montres, chacune avec sa rubrique et son
       entre-cornes : la montre de référence se lit sur la rubrique d'où part le
       clic, pas sur le bloc entier. */
    var rubrique = declencheur.closest('[data-daw-montre]');
    if (!rubrique) return;

    cfg.dataset.retour = '';
    cfg.dataset.tiroir = declencheur.closest('cart-drawer') ? '1' : '';
    modeConfig(cfg, true);
    cfg.querySelector('.daw-cfg__boite').innerHTML =
      '<p class="daw-cfg__prix" style="padding:2rem 0">Chargement…</p>';

    charger(handle).then(function (produit) {
      if (!produit) {
        modeConfig(cfg, false);
        return;
      }
      peindre(rubrique, cfg, produit, declencheur);
    });
  }

  function charger(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (p) {
        if (p) cache[handle] = p;
        return p;
      })
      .catch(function () {
        return null;
      });
  }

  /* ── construction de l'écran ────────────────────────────────────────────── */
  function peindre(rubrique, cfg, produit, declencheur) {
    var mmMontre = nombreDe(rubrique.getAttribute('data-daw-mm'));
    var boucleMontre = (rubrique.getAttribute('data-daw-boitier') || '').toLowerCase();
    var montreTitre = rubrique.getAttribute('data-daw-montre') || '';
    var montreCle = rubrique.getAttribute('data-daw-cle') || '';
    var noms = nomsOptions(produit);
    var choix = [];

    /* la largeur d'abord : c'est elle qui décide si le bracelet se fixe */
    var ordre = [];
    noms.forEach(function (n, i) {
      if (estLargeur(n)) ordre.push(i);
    });
    noms.forEach(function (n, i) {
      if (!estLargeur(n)) ordre.push(i);
    });

    /* présélection */
    noms.forEach(function (nom, i) {
      var valeurs = valeursDe(produit, i);
      var retenu = null;
      if (estLargeur(nom) && mmMontre) {
        valeurs.forEach(function (v) {
          if (!retenu && nombreDe(v) === mmMontre && dispo(produit, i, v, choix)) retenu = v;
        });
      }
      if (!retenu && estBoucle(nom) && boucleMontre) {
        valeurs.forEach(function (v) {
          if (!retenu && v.toLowerCase() === boucleMontre) retenu = v;
        });
      }
      if (!retenu) {
        valeurs.forEach(function (v) {
          if (!retenu && dispoSeul(produit, i, v)) retenu = v;
        });
      }
      choix[i] = retenu || valeurs[0];
    });

    var boite = cfg.querySelector('.daw-cfg__boite');
    boite.innerHTML = '';
    boite.appendChild(barreRetour(cfg));
    boite.appendChild(carrousel(produit));

    var titre = document.createElement('h3');
    titre.className = 'daw-cfg__titre';
    titre.textContent = produit.title;
    boite.appendChild(titre);

    var prix = document.createElement('p');
    prix.className = 'daw-cfg__prix';
    boite.appendChild(prix);

    var groupes = {};
    ordre.forEach(function (i) {
      var g = groupe(produit, i, noms[i], mmMontre, montreTitre, function (valeur) {
        choix[i] = valeur;
        rafraichir();
      });
      groupes[i] = g;
      boite.appendChild(g.racine);
    });

    if (produit.description) {
      var fiche = document.createElement('div');
      fiche.className = 'daw-fiche';
      fiche.style.display = 'block';
      fiche.innerHTML = produit.description;
      boite.appendChild(fiche);
    }

    var pied = document.createElement('div');
    pied.className = 'daw-cfg__pied';
    var bouton = document.createElement('button');
    bouton.type = 'button';
    bouton.className = 'daw-cfg__ajout';
    pied.appendChild(bouton);
    var erreur = document.createElement('p');
    erreur.className = 'daw-cfg__erreur';
    erreur.hidden = true;
    pied.appendChild(erreur);
    boite.appendChild(pied);

    function variantRetenue() {
      var trouvee = null;
      produit.variants.forEach(function (v) {
        if (trouvee) return;
        var bon = true;
        choix.forEach(function (c, i) {
          if (v.options[i] !== c) bon = false;
        });
        if (bon) trouvee = v;
      });
      return trouvee;
    }

    function rafraichir() {
      ordre.forEach(function (i) {
        groupes[i].maj(choix, i);
      });
      var v = variantRetenue();
      prix.textContent = v ? euros(v.price) : euros(produit.price);
      if (v && v.available) {
        bouton.disabled = false;
        bouton.textContent = 'AJOUTER AU PANIER — ' + euros(v.price);
        erreur.hidden = true;
      } else {
        bouton.disabled = true;
        bouton.textContent = 'COMBINAISON ÉPUISÉE';
        erreur.hidden = false;
        erreur.textContent = 'Cette combinaison n’est plus disponible. Changez une des sélections.';
      }
    }

    bouton.addEventListener('click', function () {
      var v = variantRetenue();
      if (!v || !v.available) return;
      bouton.disabled = true;
      bouton.textContent = 'AJOUT EN COURS…';
      ajouter(v.id, montreTitre, montreCle).then(function (ok) {
        if (ok) {
          modeConfig(cfg, false);
          if (declencheur && document.contains(declencheur)) declencheur.focus();
        } else {
          bouton.disabled = false;
          erreur.hidden = false;
          erreur.textContent = 'L’ajout n’a pas abouti. Réessayez dans un instant.';
          rafraichir();
        }
      });
    });

    rafraichir();
    if (cfg.scrollIntoView) cfg.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    var r = cfg.querySelector('.daw-cfg__retour');
    if (r) r.focus();
  }

  function valeursDe(produit, i) {
    var vues = [];
    produit.variants.forEach(function (v) {
      if (vues.indexOf(v.options[i]) < 0) vues.push(v.options[i]);
    });
    return vues;
  }

  /* une valeur est-elle tenable avec les autres choix en cours ? */
  function dispo(produit, i, valeur, choix) {
    var ok = false;
    produit.variants.forEach(function (v) {
      if (ok || !v.available || v.options[i] !== valeur) return;
      var bon = true;
      choix.forEach(function (c, j) {
        if (j !== i && c && v.options[j] !== c) bon = false;
      });
      if (bon) ok = true;
    });
    return ok;
  }

  function dispoSeul(produit, i, valeur) {
    return produit.variants.some(function (v) {
      return v.available && v.options[i] === valeur;
    });
  }

  function barreRetour(cfg) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'daw-cfg__retour';
    b.innerHTML =
      '<svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M10 3L5 8l5 5"/></svg> Retour';
    b.addEventListener('click', function () {
      modeConfig(cfg, false);
    });
    return b;
  }

  function carrousel(produit) {
    var medias = (produit.media || []).slice();
    /* les photos d'abord, la vidéo ensuite */
    medias.sort(function (a, b) {
      var pa = a.media_type === 'image' ? 0 : 1;
      var pb = b.media_type === 'image' ? 0 : 1;
      return pa - pb;
    });
    if (!medias.length && produit.featured_image) {
      medias = [{ media_type: 'image', src: produit.featured_image }];
    }

    var carr = document.createElement('div');
    carr.className = 'daw-carr';
    var piste = document.createElement('div');
    piste.className = 'daw-carr__piste';
    carr.appendChild(piste);

    medias.forEach(function (m) {
      var vue = document.createElement('div');
      vue.className = 'daw-carr__vue';
      if (m.media_type === 'video' && m.sources && m.sources.length) {
        var v = document.createElement('video');
        v.setAttribute('controls', '');
        v.setAttribute('preload', 'none');
        if (m.preview_image) v.setAttribute('poster', m.preview_image.src || m.preview_image);
        var s = document.createElement('source');
        s.src = m.sources[m.sources.length - 1].url;
        v.appendChild(s);
        vue.appendChild(v);
        var e = document.createElement('span');
        e.className = 'daw-etiq';
        e.textContent = 'Vidéo';
        vue.appendChild(e);
      } else {
        var img = document.createElement('img');
        img.loading = 'lazy';
        img.alt = m.alt || produit.title;
        img.src = (m.src || (m.preview_image && m.preview_image.src) || '') + (String(m.src || '').indexOf('?') >= 0 ? '&' : '?') + 'width=800';
        vue.appendChild(img);
      }
      piste.appendChild(vue);
    });

    if (medias.length > 1) {
      var g = fleche('‹', 'g');
      var d = fleche('›', 'd');
      carr.appendChild(g);
      carr.appendChild(d);
      var points = document.createElement('div');
      points.className = 'daw-carr__points';
      medias.forEach(function (m, i) {
        var p = document.createElement('button');
        p.type = 'button';
        p.className = 'daw-carr__point';
        p.setAttribute('aria-label', 'Média ' + (i + 1) + ' sur ' + medias.length);
        p.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        p.addEventListener('click', function () {
          aller(i);
        });
        points.appendChild(p);
      });
      carr.appendChild(points);

      var majPoints = function () {
        var i = Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth));
        [].forEach.call(points.children, function (p, j) {
          p.setAttribute('aria-current', j === i ? 'true' : 'false');
        });
      };
      var aller = function (i) {
        i = Math.max(0, Math.min(medias.length - 1, i));
        piste.scrollTo({ left: i * piste.clientWidth, behavior: 'smooth' });
      };
      piste.addEventListener('scroll', majPoints, { passive: true });
      g.addEventListener('click', function () {
        aller(Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth)) - 1);
      });
      d.addEventListener('click', function () {
        aller(Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth)) + 1);
      });
    }
    return carr;
  }

  function fleche(signe, cote) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'daw-carr__fleche daw-carr__fleche--' + cote;
    b.setAttribute('aria-label', cote === 'g' ? 'Média précédent' : 'Média suivant');
    b.textContent = signe;
    return b;
  }

  /* un groupe d'options : largeur en pastilles, le reste en teintes */
  function groupe(produit, i, nom, mmMontre, montreTitre, auChoix) {
    var largeur = estLargeur(nom);
    var racine = document.createElement('div');
    racine.className = 'daw-opt';

    var titre = document.createElement('div');
    titre.className = 'daw-opt__nom';
    titre.appendChild(document.createTextNode(nom));
    var valeurDite = document.createElement('span');
    valeurDite.className = 'daw-opt__val';
    titre.appendChild(valeurDite);
    racine.appendChild(titre);

    var choixEl = document.createElement('div');
    choixEl.className = 'daw-choix';
    choixEl.setAttribute('role', 'group');
    choixEl.setAttribute('aria-label', nom);
    racine.appendChild(choixEl);

    var ok = null;
    var non = null;
    if (largeur && mmMontre) {
      ok = dire('C’est la largeur de votre ' + (montreTitre || 'montre'), false);
      non = dire(
        'Votre ' + (montreTitre || 'montre') + ' mesure ' + mmMontre + ' mm : cette largeur ne s’y fixera pas.',
        true
      );
      racine.appendChild(ok);
      racine.appendChild(non);
    }

    var boutons = [];
    valeursDe(produit, i).forEach(function (valeur) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-valeur', valeur);
      if (largeur) {
        b.className = 'daw-mes';
        b.textContent = valeur;
        if (mmMontre && nombreDe(valeur) === mmMontre) b.setAttribute('data-sienne', '');
      } else {
        b.className = 'daw-teinte';
        b.setAttribute('aria-label', valeur);
        b.title = valeur;
        var pastille = document.createElement('i');
        var t = teinte(produit, i, valeur);
        if (t.image) {
          pastille.style.backgroundImage = 'url(' + t.image + ')';
        } else {
          pastille.style.background = t.couleur;
        }
        b.appendChild(pastille);
      }
      b.addEventListener('click', function () {
        if (b.disabled) return;
        auChoix(valeur);
      });
      choixEl.appendChild(b);
      boutons.push(b);
    });

    return {
      racine: racine,
      maj: function (choix, index) {
        var retenu = choix[index];
        valeurDite.textContent = retenu || '';
        boutons.forEach(function (b) {
          var v = b.getAttribute('data-valeur');
          b.setAttribute('aria-pressed', v === retenu ? 'true' : 'false');
          b.disabled = !dispo(produit, index, v, choix) && !dispoSeul(produit, index, v);
        });
        if (ok && non) {
          var sienne = mmMontre && nombreDe(retenu) === mmMontre;
          ok.hidden = !sienne;
          non.hidden = !!sienne;
        }
      }
    };
  }

  function dire(texte, averti) {
    var p = document.createElement('p');
    p.className = 'daw-dit' + (averti ? ' daw-dit--averti' : '');
    var pt = document.createElement('span');
    pt.className = 'daw-dit__pt';
    pt.setAttribute('aria-hidden', 'true');
    p.appendChild(pt);
    p.appendChild(document.createTextNode(texte));
    p.hidden = true;
    return p;
  }

  /* la pastille : couleur du nuancier Shopify si elle existe, sinon le nom */
  function teinte(produit, i, valeur) {
    var nuancier = window.DAW_NUANCIER || {};
    var cle = (produit.handle + '|' + i + '|' + valeur).toLowerCase();
    if (nuancier[cle]) return nuancier[cle];
    var simple = valeur.toLowerCase();
    if (nuancier[simple]) return nuancier[simple];
    return { couleur: motCouleur(simple) };
  }

  var MOTS = {
    noir: '#1a1a1a',
    blanc: '#f2f2f2',
    cognac: '#8a5a2b',
    havane: '#5d3a20',
    marron: '#5d3a20',
    brun: '#5d3a20',
    gris: '#6e6e6e',
    'gris ardoise': '#55595c',
    kaki: '#4a5640',
    sable: '#7a6a4f',
    beige: '#c8b38a',
    bleu: '#2f4a6d',
    'bleu marine': '#1f2f4a',
    vert: '#3d5c43',
    bordeaux: '#5e2130',
    rouge: '#8c2f2f',
    or: '#d49a06',
    'or rose': '#b76e54',
    acier: '#d3d3d3',
    argent: '#d3d3d3',
    'acier noirci': '#3a3a3a'
  };

  function motCouleur(valeur) {
    var trouve = '';
    Object.keys(MOTS).forEach(function (mot) {
      if (valeur.indexOf(mot) >= 0 && mot.length > trouve.length) trouve = mot;
    });
    return trouve ? MOTS[trouve] : 'rgba(128,128,128,0.4)';
  }

  /* ── ajout direct, pour ce qui n'a pas de déclinaison ───────────────────── */
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-daw-ajout]');
    if (!b) return;
    ev.preventDefault();
    var rubrique = b.closest('[data-daw-montre]');
    b.disabled = true;
    ajouter(
      b.getAttribute('data-daw-ajout'),
      rubrique ? rubrique.getAttribute('data-daw-montre') : '',
      rubrique ? rubrique.getAttribute('data-daw-cle') : ''
    ).then(function (ok) {
      if (!ok) b.disabled = false;
    });
  });

  /* ── l'ajout et le retour au panier ────────────────────────────────── */
  function ajouter(variantId, montreTitre, montreCle) {
    var corps = {
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    };
    if (montreTitre) {
      /* propriété visible : Dawn l'affiche sous la ligne, et elle suit jusqu'au bon de préparation */
      corps.items[0].properties = { Pour: montreTitre, _daw_cle: montreCle || '' };
    }
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(corps)
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.status) return false;
        rendre(data);
        return true;
      })
      .catch(function () {
        return false;
      });
  }

  /* Le panier vient de passer de vide à non vide. Dawn porte « is-empty » sur
     <cart-drawer>, qui est HORS de #CartDrawer et n'est donc pas remplacé par
     renderContents. Tant que la classe reste, l'en-tête et les lignes du panier
     sont repliés à zéro : l'article est bien au panier mais ne s'affiche qu'au
     chargement de page suivant. Dawn fait exactement ce même nettoyage dans son
     propre formulaire produit. */
  function plusVide(tiroir) {
    if (!tiroir) return;
    tiroir.classList.remove('is-empty');
    tiroir.querySelectorAll('.is-empty').forEach(function (el) {
      el.classList.remove('is-empty');
    });
  }

  function rendre(data) {
    var tiroir = document.querySelector('cart-drawer');
    if (tiroir && typeof tiroir.renderContents === 'function') {
      try {
        tiroir.renderContents(data);
        plusVide(tiroir);
        return;
      } catch (e) {
        /* on retombe sur le remplacement manuel */
      }
    }
    if (!data.sections) {
      window.location.reload();
      return;
    }
    var doc = new DOMParser().parseFromString(data.sections['cart-drawer'] || '', 'text/html');
    var neuf = doc.querySelector('#CartDrawer');
    var actuel = document.querySelector('#CartDrawer');
    if (neuf && actuel) actuel.innerHTML = neuf.innerHTML;

    var bulleDoc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'] || '', 'text/html');
    var bulleNeuve = bulleDoc.querySelector('.shopify-section');
    var bulle = document.querySelector('#cart-icon-bubble');
    if (bulleNeuve && bulle && bulle.parentElement) bulle.parentElement.innerHTML = bulleNeuve.innerHTML;

    if (tiroir) {
      plusVide(tiroir);
      if (typeof tiroir.open === 'function') tiroir.open();
    }
  }

  /* Échap referme l'écran de configuration avant le tiroir */
  document.addEventListener(
    'keydown',
    function (ev) {
      if (ev.key !== 'Escape') return;
      var ouvert = document.querySelector('.daw-cfg:not([hidden])');
      if (ouvert) {
        ev.stopPropagation();
        modeConfig(ouvert, false);
      }
    },
    true
  );
})();
